import { connect } from 'react-redux';
import React, { PropTypes } from 'react';
import { updateData } from '../actions/form';
import { Button, Icon, Form, Table, Segment } from 'semantic-ui-react';
import Modal from 'modules/common/components/Modal';
import dotProp from 'dot-prop-immutable';

export class Products extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      modalOpened: false,
      currentLine: this.emptyLine(),
    };

    this.addClick = this.addClick.bind(this);
    this.onClose = this.onClose.bind(this);
    this.updateField = this.updateField.bind(this);
    this.saveClicked = this.saveClicked.bind(this);
    this.updateProduct = this.updateProduct.bind(this);
  }

  emptyLine() {
    return {
      id: undefined,
      productId: undefined,
      productLabel: undefined,
      qte: undefined,
      comment: undefined,
      productError: false,
      qteError: false,
    };
  }

  addClick() {
    this.setState({
      ...this.state,
      modalOpened: true,
      currentLine: this.emptyLine(),
      currentIndex: -1,
    });
  }

  updateClick(index) {
    this.setState({
      ...this.state,
      currentLine: this.props.lines[index],
      currentIndex: index,
      modalOpened: true,
    });
  }

  onSave(index, line) {
    const updatedLines = this.props.lines ? [...this.props.lines] : [];
    if (index === -1) {
      updatedLines.push(line);
    } else {
      updatedLines[index] = line;
    }
    this.props.updateLines(updatedLines);
    this.onClose();
  }

  onDelete(index) {
    const updatedLines = [...this.props.lines];
    updatedLines.splice(index, 1);
    this.props.updateLines(updatedLines);
  }

  onClose() {
    this.setState({
      ...this.state,
      modalOpened: false,
    });
  }

  updateField(name, value) {
    this.setState(dotProp.set(this.state, `currentLine.${name}`, value));
  }

  updateProduct(_, value) {
    this.setState({
      ...this.state,
      currentLine: {
        ...this.state.currentLine,
        productId: value.value,
        productLabel: this.props.products.find(o => o.id === value.value).label,
      },
    });
  }

  saveClicked() {
    let qteError = false;
    if (
      isNaN(this.state.currentLine.qte) ||
      !Number.isInteger(Number(this.state.currentLine.qte))
    ) {
      qteError = true;
    }

    let productError = false;
    if (this.state.currentLine.productId === undefined) {
      productError = true;
    }

    if (qteError || productError) {
      this.setState({
        ...this.state,
        currentLine: {
          ...this.state.currentLine,
          productError: productError,
          qteError: qteError,
        },
      });
    } else {
      this.onSave(this.state.currentIndex, {
        ...this.state.currentLine,
        qte: Number(this.state.currentLine.qte),
      });
    }
  }

  render() {
    const productChoices = this.props.products.map(p => ({
      key: p.id,
      value: p.id,
      text: p.label,
    }));

    return (
      <div>
        <Form.Field style={{ marginBottom: '20px' }}>
          <label>Matériel nécessaire</label>
          <Button
            icon
            labelPosition="left"
            floated="right"
            style={{ marginBottom: '5px' }}
            onClick={this.addClick}
            disabled={this.props.readOnly}
          >
            <Icon name="add" />
            Ajouter
          </Button>
          {this.props.lines &&
            this.props.lines.length > 0 && (
              <Table compact>
                <Table.Header>
                  <Table.Row key="head">
                    <Table.HeaderCell>Produit</Table.HeaderCell>
                    <Table.HeaderCell>Quantité</Table.HeaderCell>
                    <Table.HeaderCell>Commentaire</Table.HeaderCell>
                    <Table.HeaderCell />
                  </Table.Row>
                </Table.Header>

                <Table.Body>
                  {this.props.lines.map((line, index) => (
                    <Table.Row key={index}>
                      <Table.Cell> {line.productLabel}</Table.Cell>
                      <Table.Cell> {line.qte}</Table.Cell>
                      <Table.Cell> {line.comment}</Table.Cell>
                      <Table.Cell>
                        {' '}
                        <Button
                          basic
                          icon="edit"
                          onClick={() => this.updateClick(index)}
                          disabled={this.props.readOnly}
                        />{' '}
                        <Button
                          basic
                          icon="trash"
                          onClick={() => this.onDelete(index)}
                          disabled={this.props.readOnly}
                        />{' '}
                      </Table.Cell>
                    </Table.Row>
                  ))}
                </Table.Body>
              </Table>
            )}
          {(!this.props.lines || this.props.lines.length === 0) && (
            <Segment style={{ backgroundColor: '#f9fafb', clear: 'both' }}>
              Aucune ligne
            </Segment>
          )}
        </Form.Field>
        <Modal
          isOpened={this.state.modalOpened}
          onClose={this.onClose}
          closable
        >
          <div className="header">Produit</div>
          <div className="content">
            <Form>
              <Form.Select
                label="Produit"
                value={this.state.currentLine.productId}
                onChange={this.updateProduct}
                options={productChoices}
                required
                error={this.state.currentLine.productError}
                disabled={this.props.readOnly}
              />
              <Form.Input
                label="Quantité"
                value={this.state.currentLine.qte || ''}
                onChange={(_, value) => this.updateField('qte', value.value)}
                error={this.state.currentLine.qteError}
                readOnly={this.props.readOnly}
              />
              <Form.Input
                label="Commentaire"
                value={this.state.currentLine.comment || ''}
                onChange={(_, value) =>
                  this.updateField('comment', value.value)
                }
                readOnly={this.props.readOnly}
              />
            </Form>
          </div>
          <div className="actions">
            <button
              className="ui primary button"
              onClick={this.saveClicked}
              disabled={this.props.readOnly}
            >
              <i className="icon save" />
              Enregistrer
            </button>
          </div>
        </Modal>
      </div>
    );
  }
}

Products.propTypes = {
  lines: PropTypes.array,
  updateLines: PropTypes.func.isRequired,
  products: PropTypes.array.isRequired,
};

const mapStateToProps = (state, ownProps) => ({
  lines: state.form.form.products,
  products: state.requirements.products,
});

const mapDispatchToProps = (dispatch, ownProps) => ({
  updateLines: lines => dispatch(updateData('products', lines)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Products);



// WEBPACK FOOTER //
// ./src/modules/saas/aast/case-study/components/Products.js